import { get, post } from 'vio-libs';
export function getAuthConnection(email) {
    const urlEncodedEmail = encodeURIComponent(email);
    return get(`auth-connection?email=${urlEncodedEmail}`);
}
export function getAuthConnections() {
    return get('auth-connection');
}
export function postLogin(idToken, consumerAPI = false) {
    if (!consumerAPI) {
        return post('login', {
            data: {},
            headers: {
                Authorization: `Bearer ${idToken}`
            }
        });
    }
    return post('v1/login', {
        data: {},
        headers: {
            Authorization: `Bearer ${idToken}`
        }
    }, true);
}
export function postLogout(consumerAPI = false) {
    if (!consumerAPI) {
        return post('logout', {
            data: {}
        });
    }
    return post('v1/logout', {
        data: {}
    }, true);
}
